module.exports = __webpack_public_path__ + "static/media/html.68aab8d0.svg";